export class EffectNodeBase {
}
